var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bottom-view"},[_c('div',{staticClass:"centerBottom"},[_c('div',[_vm._v(" ©Copyright 2011 - 2025 by PiscoMed Publishing Pte. Ltd. All Rights Reserved ")])])])
}]

export { render, staticRenderFns }